<template>
  <v-btn elevation="2" class="button-position d-flex align-center px-2 mediumGreen" v-if="areasFormatter">
    <span class="mx-3 white--text text-h5">{{
    `${areasFormatter}`
    }}</span>
  </v-btn>
</template>
<script>
export default {
  name: "TitleButton",
  computed: {
    point() {
      return this.$store.getters.point
    },
    areasFormatter() {
      if (this.point) {
        let result = this.point.areas?.map(area => this.$store.getters.areaById(area)?.title)?.filter(a => a)
        result = result?.length ? "נחלת שבט " + result?.join(' / ')?.toString() : ""
        return result
      }
      return ""
    },
  },
}
</script>
<style lang="scss" scoped>
.button-position {
  position: absolute;
  left: 50%;
  top: 10%;
  z-index: 1;
  transform: translateX(-50%);
}
</style>
  